var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.content,"disabled":!_vm.overflowing,"placement":"top","open-delay":160}},[_c('span',_vm._g(_vm._b({ref:"text",staticClass:"overflow-text",on:{"mouseenter":_vm.measure,"focus":_vm.measure}},'span',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }